<div class="chart-wrapper" style="display: flex; justify-content: center; height: 60px; " >
    <canvas baseChart
      [datasets]="pieChartData"
      [options]="pieChartOptions"
      [labels]="pieChartLabels"
      [legend]="pieChartLegend"
      [type]="pieChartType"
      >
    </canvas>
</div>